import { useEffect } from "react";
import { useState } from "react";
import { useAuthState } from "../../../../../context";
import { Card } from "react-bootstrap";
import { Button, CardBody, Col, Row, UncontrolledTooltip, CardHeader, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import RTable from './../../../../table';
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { hideMenuTypeBar, showMenuTypeBar } from "../../../../../actions/menuTypeAction";
import { useMenuTypeDispatch } from "../../../../../context/MenuTypeContext";
import { toast } from "react-toastify";
import { getSchoolList, getAllInventorySiteListData, deleteInventorySiteBysiteId } from "../../../../../actions/inventorySiteActions";
import { MessageConst } from "../../../../../helpers/messageConst";


const InventorySiteList = (props) => {
    const { otherInfo } = useAuthState();
    const dispatch = useMenuTypeDispatch();
    const location = useLocation();
    const [inventorySite, setInventorySite] = useState([]);
    const [loading, setLoading] = useState(false);
    const [countryDetails, setCountryDetails] = useState({});
    const [schools, setSchools] = useState([]);
    const [deleteLoading, setDeleteLoading] = useState(false);
    const [deleteConform, setDeleteConform] = useState(false);
    const [deleteRec, setDeleteRec] = useState(undefined);


    useEffect(() => {
        hideMenuTypeBar(dispatch);
        return async () => {
            await showMenuTypeBar(dispatch);
        }
    }, []);

    useEffect(() => {
        getSchoolData();
        getInvetoryListData();
    }, []);

    const getSchoolData = async () => {
        let d = new Date();
        let month = '' + (d.getMonth() + 1);
        let day = '' + d.getDate();
        let year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        let curr_date = `${[year, month, day].join('-')}`;

        const res = await getSchoolList("ROLE_CATERER", curr_date);
        console.log("Res::::::", res);
        if (res.success) {
            console.log(res.data.schools);
            setSchools(res.data.schools);
        }
    }

    const getInvetoryListData = async (req) => {
        try {
            setLoading(true);
            const res = await getAllInventorySiteListData({ catererId: otherInfo.catererId });
            console.log("getAllInventorySiteListData::::::", res);
            if (res.success) {
                console.log("response:::::::::", res.data.data);
                //let resp = res.data.data || [];
                setInventorySite(res.data.data || []);
                console.log("response11:::::::::", inventorySite);
            }
            setLoading(false);
        } catch (error) {
            console.log(error)
        }
    }

    const onDeleteInventorySite = async () => {
        const siteId = deleteRec;
        setDeleteLoading(true);
        const resp = await deleteInventorySiteBysiteId(otherInfo.catererId, siteId); // need to change this api once we got actual url of the delte api
        setDeleteLoading(false);
        getInvetoryListData();
        if (!resp.error) {
            hideDeleteConform();
            getInvetoryListData();
            toast.success(MessageConst.Inv_Site_Del);
        } else {
            toast.error(resp.errorMessage);
        }
    }

    const showDeleteConform = (rec) => {
        setDeleteConform(true);
        setDeleteRec(rec);
    };
    const hideDeleteConform = () => {
        setDeleteConform(false);
        setDeleteRec(undefined);
    };

    const getCols = () => {
        const cols = [{
            Header: 'Inventory Site',
            accessor: 'siteName',
            style: { width: '200px' },

        }];
        (schools || []).map(school => {
            cols.push({
                Header: school.schoolName,
                accessor: school.schoolName,
                style: { textAlign: 'center', width: '200px' },
                Cell: ({ row }) => {
                    const selectButtonID = `selectButton-${row.index}`;
                    const index = row.index;
                    //console.log("row:::::",row);
                    //console.log("index:::",index);
                    //console.log("row._original.schools[0]['schoolName']:::",row.original.schools[0].schoolName);
                    //console.log("school.schoolName:::",school.schoolName);

                    const schoolIndex = row.original.schools.findIndex(item => item.schoolId == school.schoolId);
                    console.log("schoolIndex:::", schoolIndex);


                    return (
                        <input
                            id={selectButtonID}
                            type="checkbox"
                            checked={(schoolIndex !== -1 && row.original.schools[schoolIndex].schoolId == school.schoolId) ? true : false}
                            readOnly
                        />
                    );
                }
            })
        })
        cols.push({
            Header: 'Action',
            style: { width: '200px' },
            Cell: ({ row }) => {
                const editButtonId = `editButton-${row.index}`;
                const deleteButtonId = `deleteButton-${row.index}`;
                return <>
                    <Button id={editButtonId} color="falcon-primary" size="sm" className='mr-1' onClick={(e) => {
                        props.history.push({
                            pathname: `/settings/addNewInventorySite`, state: {
                                isEdit: true,
                                selectedData: row.original.siteId,
                                schools: schools,
                                source: location.pathname,
                                inventorySite: inventorySite
                            }
                        });
                    }}>
                        <FontAwesomeIcon icon="pencil-alt" transform="shrink-3" /> Edit
                    </Button>
                    <UncontrolledTooltip
                        placement="bottom" target={editButtonId}
                    >
                        Edit
                    </UncontrolledTooltip>
                    <Button id={deleteButtonId} color="falcon-primary" size="sm" className='mr-1' onClick={(e) => { showDeleteConform(row.original.siteId) }}>
                        <FontAwesomeIcon icon="trash" transform="shrink-3" /> Delete
                    </Button>
                    <UncontrolledTooltip placement="top" target={deleteButtonId}>
                        Delete
                    </UncontrolledTooltip>
                </>
            }
        }
        )
        return cols;

    }

    const renderDeleteConfirmation = () => {
        return <Modal isOpen={deleteConform} toggle={hideDeleteConform}>
            <ModalHeader toggle={hideDeleteConform}>Delete Confirmation</ModalHeader>
            <ModalBody>
                Are you sure you want to delete this Site?
            </ModalBody>
            <ModalFooter>
                <Button className='mr-1' color="secondary" onClick={() => hideDeleteConform()}>No</Button>
                <Button color="primary" disabled={deleteLoading} onClick={() => onDeleteInventorySite()}>Yes</Button>
            </ModalFooter>
        </Modal>
    }

    return (<div>
        <Card>
            <CardHeader className='p-2 bg-light'>
                <Row>
                    <Col className='align-self-center'><h5 className='text-primary fw-bold mb-0' style={{ marginLeft: "2%" }}>{`Inventory Site List`}</h5></Col>
                    <Col className='d-flex justify-content-end'>
                        <Button color="falcon-primary" size="sm" style={{ marginRight: "2%" }} onClick={(e) => {
                            props.history.push({
                                pathname: `/settings/addNewInventorySite`, state: {
                                    data: {},
                                    countryDetails: countryDetails,
                                    schools: schools,
                                    inventorySite: inventorySite
                                }
                            });
                        }}>
                            <FontAwesomeIcon icon="plus" transform="shrink-3" className="mr-1" />
                            Add New
                        </Button>
                    </Col>
                </Row>
            </CardHeader>
            <CardBody>
                <Row>
                    <Col xs={12} md={12} className="mt-2">
                        <RTable loading={loading} columns={getCols()}
                            data={inventorySite} minRows="10" defaultPageSize={10} />
                    </Col>
                </Row>
            </CardBody>
            {
                renderDeleteConfirmation()
            }
        </Card>
    </div>)
}
export default InventorySiteList